import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

import "./styles/tokens.css";
import "./styles/home.css";
import "./styles/pages.css";
import "./styles/upgrade.css";
import "./styles/signature.css";
import "./styles/extras.css";
import "./styles/polish.css";
import "./styles/discipline.css";
import "./styles/department.css";
import "./styles/editorial.css";
import "./styles/placement-charts.css";
import "./styles/typography.css";
import "./styles/density.css";
import "./styles/motion.css";
import "./styles/mega-menu.css";
import "./styles/heritage.css";
import "./styles/data-design.css";
import "./styles/hero-fix.css";
import "./styles/theme-controls.css";
import "./styles/event.css";
import "./styles/figure.css";
import "./styles/detail.css";
import "./styles/leaders.css";
import "./styles/alumni.css";
import "./styles/visits.css";
import "./styles/mobile.css";
import "./styles/page-tabs.css";
import "./styles/notifications.css";
import "./styles/social.css";
import "./styles/examinations.css";
import "./styles/dean-band.css";
import "./styles/service-wings.css";
import "./styles/gallery.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
